function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function openDeleteVersionModal(input: {
  componentName: string;
  version: number;
  /** True when this version is the promoted (live) one — deleting it
   *  changes what pasted snippets serve, so the warning is louder. */
  isCurrent?: boolean;
}): Promise<boolean> {
  return new Promise((resolve) => {
    const dialog = document.createElement('sl-dialog');
    dialog.label = `Delete v${input.version}`;
    const currentNote = input.isCurrent
      ? `<br><strong>This version is currently live</strong> — the latest
         remaining version will become the current bundle, changing what
         every pasted snippet serves.`
      : `<br>This version is not live; the current bundle is unaffected.`;
    dialog.innerHTML = `
      <div class="field-stack">
        <sl-alert variant="warning" open>
          <sl-icon slot="icon" name="exclamation-triangle"></sl-icon>
          <strong>This cannot be undone.</strong>
          Version <code>v${input.version}</code> of
          <code>${escapeHtml(input.componentName)}</code> will be permanently removed.
          ${currentNote}
        </sl-alert>
      </div>

      <sl-button slot="footer" id="dv-cancel" variant="default">Cancel</sl-button>
      <sl-button slot="footer" id="dv-delete" variant="danger">Delete version</sl-button>
    `;

    document.body.appendChild(dialog);

    const cancelBtn = dialog.querySelector<HTMLElement>('#dv-cancel')!;
    const deleteBtn = dialog.querySelector<HTMLElement>('#dv-delete')!;
    let confirmed = false;

    cancelBtn.addEventListener('click', () => dialog.hide());
    deleteBtn.addEventListener('click', () => {
      confirmed = true;
      dialog.hide();
    });
    dialog.addEventListener('sl-after-hide', () => {
      dialog.remove();
      resolve(confirmed);
    });

    requestAnimationFrame(() => {
      (dialog as HTMLElement & { show: () => void }).show();
    });
  });
}
